import Vue from 'vue';

const state = {
	checkIns: [],
	checkInTemplates: [],
	checkIns_loading: false
};

const getters = {
	checkIns: state => state.checkIns,
	checkInTemplates: state => state.checkInTemplates,
	checkInsAllList: (state, getters, rootState, rootGetters) => {
		let filtered = null;
		filtered = state.checkIns;

		return filtered.map(review => ({
			id: review.id,
			employee: review.employee.fullName,
			employeeId: review.employee.id,
			reviewer: review.reviewer.fullName,
			reviewerId: review.reviewer.id,
			isLoggedInEmployee: review.employee.id === rootGetters['loggedInEmployee'].id,
			isLoggedInReviewer: review.reviewer.id === rootGetters['loggedInEmployee'].id,
			name: review.name,
			dueDateUtc: review.dueDateUtc,
			createdDateUtc: review.createdDateUtc,
			updatedDateUtc: review.updatedDateUtc,
			status: review.status
		}));
	},
	checkInsPendingList: (state, getters, rootState, rootGetters) => {
		let filtered = null;
		filtered = state.checkIns;
		filtered = filtered.filter(p => p.status !== 'Complete').sort((a, b) => new Date(a.createdDateUtc) - new Date(b.createdDateUtc));

		return filtered.map(review => ({
			id: review.id,
			employee: review.employee.fullName,
			employeeId: review.employee.id,
			reviewer: review.reviewer.fullName,
			reviewerId: review.reviewer.id,
			isLoggedInEmployee: review.employee.id === rootGetters['loggedInEmployee'].id,
			isLoggedInReviewer: review.reviewer.id === rootGetters['loggedInEmployee'].id,
			name: review.name,
			dueDateUtc: review.dueDateUtc,
			createdDateUtc: review.createdDateUtc,
			updatedDateUtc: review.updatedDateUtc,
			status: review.status
		}));
	},
	checkInsCompletedList: (state, getters, rootState, rootGetters) => {
		
		let filtered = state.checkIns.filter(p => p.status === 'Complete');
		return filtered.map(review => ({
			id: review.id,
			employee: review.employee.fullName,
			employeeId: review.employee.id,
			reviewer: review.reviewer.fullName,
			reviewerId: review.reviewer.id,
			scheduledDate: review.scheduledDateUTC,
			isLoggedInEmployee: review.employee.id === rootGetters['loggedInEmployee'].id,
			isLoggedInReviewer: review.reviewer.id === rootGetters['loggedInEmployee'].id,
			name: review.name,
			dueDateUtc: review.dueDateUtc,
			createdDateUtc: review.createdDateUtc,
			updatedDateUtc: review.updatedDateUtc,
			status: review.status
		}));
	},
	checkInsMyPendingList: (state, getters, rootState, rootGetters) => {
		let filtered = null;
		filtered = state.checkIns.filter(p => p.status !== 'Complete' && (p.employee.id === rootGetters['loggedInEmployee'].id || p.reviewer.id === rootGetters['loggedInEmployee'].id));

		return filtered.map(review => ({
			id: review.id,
			employee: review.employee.fullName,
			employeeId: review.employee.id,
			reviewer: review.reviewer.fullName,
			reviewerId: review.reviewer.id,
			isLoggedInEmployee: review.employee.id === rootGetters['loggedInEmployee'].id,
			isLoggedInReviewer: review.reviewer.id === rootGetters['loggedInEmployee'].id,
			name: review.name,
			createdDateUtc: review.createdDateUtc,
			dueDateUtc: review.dueDateUtc,
			updatedDateUtc: review.updatedDateUtc,
			status: review.status
		}));
	},
	checkInsPendingCount: state => {
		return state.checkIns.filter(p => p.status !== 'Complete').length;		
	}
};

const actions = {
	// check ins
	async get({ commit, rootState }) {
		try {
			commit('GET_PENDING');
			var response = await Vue.axios.get(`/api/${rootState.tenantId}/checkIns`);
			commit('GET_SUCCESS', response.data);
		} catch(err) {
			commit('GET_FAILURE', error);
		}
	},
	async add({ commit, dispatch, rootState }, checkIn) {
		try {
			var result = await Vue.axios.post(`/api/${rootState.tenantId}/checkIns`, checkIn)
			commit('ADD_SUCCESS', result.data);
			dispatch('get');
			return result.data;
		} catch(err) {
			return err;
		}
	},
	async edit({ commit, dispatch, rootState }, checkIn) {
		try {
			var result = await Vue.axios.put(`/api/${rootState.tenantId}/checkIns/${checkIn.id}`, checkIn);
			commit('EDIT_SUCCESS', result.data);
			dispatch('get');
			return result.data;
		} catch(err) {
			return err;
		}
	},
	async delete({ dispatch, rootState }, checkIn) {
		try {
			let result = await Vue.axios.delete(`/api/${rootState.tenantId}/checkIns/${checkIn.id}`);
			dispatch('get');
			return result.data;
		} catch(err) {
			return err;
		}
	},
	addComment({ commit, dispatch, rootState }, { checkInId, ...comment }) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/checkIns/${checkInId}/comments`, comment)
				.then(resp => {
					commit('ADD_COMMENT_SUCCESS', { checkInId, comment: resp.data } );
					resolve(resp.data);
				})
				.catch(err => {
					console.log('Error creating Check In comment');
					console.log(err);
					reject(err);
				});
		});
	},
	deleteComment({ commit, rootState }, { checkInId, id }) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/checkIns/${checkInId}/comments/${id}`)
				.then(resp => {
					commit('DELETE_COMMENT_SUCCESS', { checkInId, id } );
					resolve(resp);
				})
				.catch(err => {
					console.log('Error deleting comment...');
					console.log(err);
					reject(err);
				});
		});
	},
};

const mutations = {
	GET_PENDING(state) {
		state.checkIns_loading = true;
	},
	GET_FAILURE(state, error) {
		state.checkIns_loading = false;
		console.log(error);
	},
	GET_SUCCESS(state, checkIns) {
		state.checkIns_loading = false;
		state.checkInTemplates = [];
		state.checkIns = [];

		if (!checkIns) {
			return;
		}

		for (let i = 0; i < checkIns.length; i++) {
			if (checkIns[i].isTemplate) {
				state.checkInTemplates.push(checkIns[i])
			} else {
				state.checkIns.push(checkIns[i])
			}
		}
	},
	ADD_SUCCESS(state, checkIn) {
		state.checkIns.push(checkIn);
	},
	EDIT_SUCCESS(state, checkIn) {
		let found = state.checkIns.find(x => x.id === checkIn.id);
		if (found != null) {
			found = checkIn;
		}
	},
	ADD_COMMENT_SUCCESS(state, { checkInId, comment }) {
		let found = state.checkIns.find(x=> x.id === checkInId);
		if (found != null) {
			found.comments.push(comment);
		}
	},
	DELETE_COMMENT_SUCCESS(state, { checkInId, id }) {
		let found = state.checkIns.find(x=> x.id === checkInId);
		if (found != null) {
			const index = found.comments.findIndex((x) => x.id === id);
			if (index > -1) {
				found.comments.splice(index, 1);
			}
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
